import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useParams } from "react-router-dom";
import { LoadingPanel } from "../../../components/layout/Loading";
import { Typography } from "@progress/kendo-react-common";
import { Button } from "@progress/kendo-react-buttons";
import { getLeadReport } from "../services/reports.services";
import { checkAcessRights } from "../../../_helper/helper";
import { EXCEL_EXPORT_ACCESS, PRINT_ACCESS } from "../../../_contstants/common";
import AlertBox from "../../../components/common/AlertBox";
import moment from "moment";

const LeadReportView = () => {
  const gridRef = React.useRef<any>(null);
  const dispatch = useAppDispatch();
  const params = useParams();
  const isExcelExportAccess = checkAcessRights(
    "/leadreportform",
    EXCEL_EXPORT_ACCESS
  );
  const isPrintAccess = checkAcessRights("/leadreportform", PRINT_ACCESS);

  const filterFromDate = params?.filterFromDate;
  const filterToDate = params?.filterToDate;
  const filterLeadSourceID = params?.filterLeadSourceID;
  const filterLeadStageID = params?.filterLeadStageID;
  const filterAssignedTo = params?.filterAssignedTo;
  const filterUnassignedLeads = params?.filterUnassignedLeads;

  const loading = useAppSelector((state) => state.reports.loading);
  const LeadListForReport = useAppSelector(
    (state) => state.reports.LeadListForReport
  );

  const [uiLoading, setLoading] = React.useState<boolean>(true);

  useEffect(() => {
    setLoading(loading);
  }, [loading]);

  useEffect(() => {
    if (filterToDate && filterFromDate) {
      const payload = {
        filterFromDate: filterFromDate !== "0" ? filterFromDate : "",
        filterToDate: filterToDate !== "0" ? filterToDate : "",
        filterLeadSourceID: filterLeadSourceID !== "0" ? filterLeadSourceID : 0,
        filterLeadStageID: filterLeadStageID !== "0" ? filterLeadStageID : 0,
        filterAssignedTo: filterAssignedTo !== "0" ? filterAssignedTo : 0,
        filterUnassignedLeads: filterUnassignedLeads === "false" ? false : true,
      };
      dispatch(getLeadReport(payload));
    }
  }, []);

  const handleExportExcel = () => {
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.table_to_sheet(
      document.querySelector(".table-bordered")
    );
    XLSX.utils.book_append_sheet(wb, ws, "LeadReport");

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(data, "leadreport.xlsx");
  };

  if (uiLoading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <>
      <div
        className="report-container"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "20px 10px",
        }}
      >
        <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
          Lead Report{" "}
          <span style={{ fontSize: 15 }}>
            {LeadListForReport &&
              LeadListForReport.length > 0 &&
              `(
              ${
                filterFromDate !== "0"
                  ? moment(filterFromDate, "YYYY-MM-DD").format("DD/MM/YYYY")
                  : ""
              }${filterFromDate !== "0" && filterToDate !== "0" ? " to " : ""}${
                filterToDate !== "0"
                  ? moment(filterToDate, "YYYY-MM-DD").format("DD/MM/YYYY")
                  : " "
              }
              )`}
          </span>
        </Typography.h4>
        <div className="printbuttons">
          {isPrintAccess &&
            LeadListForReport &&
            LeadListForReport.length > 0 && (
              <Button
                style={{ marginRight: 5 }}
                type="button"
                fillMode={"solid"}
                themeColor={"primary"}
                onClick={() => window.print()}
              >
                Print
              </Button>
            )}

          {isExcelExportAccess &&
            LeadListForReport &&
            LeadListForReport.length > 0 && (
              <Button
                type="button"
                fillMode={"solid"}
                themeColor={"primary"}
                onClick={handleExportExcel}
              >
                Excel Export
              </Button>
            )}
        </div>
      </div>
      {LeadListForReport && LeadListForReport.length > 0 ? (
        <div className="table-responsive" style={{ margin: "0 10px" }}>
          <table className="table table-bordered reportScreens lead-report">
            <thead>
              <tr>
                <th style={{ background: "black", color: "white" }}>No</th>
                <th style={{ background: "black", color: "white" }}>
                  Lead Date
                </th>
                <th style={{ background: "black", color: "white" }}>Name</th>
                <th style={{ background: "black", color: "white" }}>
                  Mobile No
                </th>
                <th style={{ background: "black", color: "white" }}>
                  Lead Source
                </th>
                <th style={{ background: "black", color: "white" }}>
                  Lead Stage
                </th>
                <th style={{ background: "black", color: "white" }}>
                  Created By
                </th>
              </tr>
            </thead>
            <tbody>
              {LeadListForReport &&
                LeadListForReport.length > 0 &&
                LeadListForReport?.map((lead: any, index: number) => (
                  <tr>
                    <td className="text-center">{index + 1}</td>
                    <td className="text-center">
                      {lead?.LeadDate
                        ? moment(lead?.LeadDate, "DD/MM/YYYY").format(
                            "DD MMM YYYY"
                          )
                        : ""}
                    </td>
                    <td>
                      {lead?.Initial +
                        " " +
                        lead?.FirstName +
                        " " +
                        lead?.LastName}
                    </td>
                    <td className="text-center">{lead?.MobileNo || ""}</td>
                    <td className="text-center">{lead?.LeadSource || ""}</td>
                    <td className="text-center">{lead?.LeadStage || ""}</td>
                    <td>{lead?.CreatedBy || ""}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      ) : (
        <AlertBox style={{ margin: "0 10px 10px" }} />
      )}
    </>
  );
};

export default LeadReportView;
